module.exports = "<div class=\"text-center\">\n  <h2 mat-dialog-title>Logout</h2>\n  <mat-dialog-content>Are you sure you want to logout?</mat-dialog-content>\n  <div class=\"row justify-content-center\">\n    <mat-dialog-actions>\n      <button mat-button mat-dialog-close id=\"cancel-logout-button\">Cancel</button>\n      <button mat-button [mat-dialog-close]=\"true\" id=\"ok-logout-button\">OK</button>\n    </mat-dialog-actions>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout-dialog.component.html
// module id = ./src/app/logout-dialog.component.html
// module chunks = main